<template>
  <div class="assignment-data-view">
    <div class="outer-container">
      <h1 class="greeting">Hello, {{ userName }}</h1>
      <div class="inner-container">
        <md-content class="scroll-content md-scrollbar gray-3 bg">
          <div class="md-layout">
            <div class="md-layout-item">
              <div class="header md-elevation-3">Pending</div>          
              <md-progress-bar v-if="loading" md-mode="indeterminate" />
              <assignment-card 
                v-for="assign in pending" 
                :key="assign.id" 
                :assignment="assign"
                @selected="selectAssignment(assign)"
                @startTask="asnmt => startTask(asnmt)"
                @deleteTask="asnmt => deleteTask(asnmt)"
              />
            </div>
            <div class="md-layout-item">
              <div class="header md-elevation-3">In Progress</div>
              <md-progress-bar v-if="loading" md-mode="indeterminate" />
              <assignment-card 
                v-for="assign in inProgress" 
                :key="assign.id" 
                :assignment="assign"
                @selected="selectAssignment(assign)"
                @completeTask="asnmt => completeTask(asnmt)"
                @deleteInProgress="asnmt => deleteInProgress(asnmt)"
              />
            </div>
            <div class="md-layout-item">
              <div class="header md-elevation-3">Complete</div>
              <md-progress-bar v-if="loading" md-mode="indeterminate" />
              <assignment-card 
                v-for="assign in complete" 
                :key="assign.id" 
                :assignment="assign"
                @selected="selectAssignment(assign)"
                @removeTask="asnmt => removeTask(asnmt)"
              />
            </div>
          </div>
        </md-content>
        <div class="details-container">
          <assignment-details 
            v-if="state.selectedAssignment"
            :assignment="state.selectedAssignment"
            :org-data="orgData"
          />
        </div>
      </div>
    </div>  
  </div>
</template>

<script>
import { userLabel } from '~lib/common/utils/labels';

import AssignmentCard from './AssignmentCard';
import AssignmentDetails from '../AssignmentList/AssignmentDetails';

export default {
  name: 'assignment-list',
  components: {
    AssignmentCard,
    AssignmentDetails,
  },
  props: {
    user: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
    },
    data: {
      type: Array,
      default: () => [],
    },
    orgData: {
      type: Object,
      default: undefined,
    },
  },
  data() {
    return {
      state: {
        selectedAssignment: null,
      },
    };
  },
  computed: {
    userName() {
      return userLabel(this.user);
    },
    pending() {
      const now = new Date().toJSON();
      return this.data.filter(a => a.startTime > now);
    },
    inProgress() {
      const now = new Date().toJSON();
      return this.data.filter(a => a.startTime <= now && a.endTime >= now);
    },
    complete() {
      const now = new Date().toJSON();
      return this.data.filter(a => a.endTime < now && a.status !== 'REMOVED');
    },
  },
  methods: {
    selectAssignment(assignment) {
      this.state.selectedAssignment = assignment;
    },
    startTask(assignment) {
      this.$emit('startTask', assignment);
    },
    deleteTask(assignment) {
      this.$emit('deleteTask', assignment);
      this.selectAssignment(undefined);
    },
    completeTask(assignment) {
      this.$emit('completeTask', assignment);
    },
    removeTask(assignment) {
      this.$emit('removeTask', assignment);
      this.selectAssignment(undefined);
    },
    deleteInProgress(assignment) {
      this.$emit('deleteInProgress', assignment);
      this.selectAssignment(undefined);
    },
  },
};
</script>

<style scoped>
.assignment-data-view {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.outer-container {
  padding: 20px 25px;  
  height: 100%;
  min-width: 500px;
}

.inner-container {
  display: flex;
  height: calc(100% - 70px);
}

.details-container {
  height: 100%;
  width: 100%;
  flex: 2;
  padding-left: 15px;
  padding-bottom: 15px;
  box-sizing: border-box;
}

.greeting {
  text-decoration: underline;  
  text-decoration-color: #0870B0;
  margin-bottom: 40px;
}

.scroll-content {
  overflow: auto;
  height: 100%;
  flex: 3;
}

.md-layout {
  width: 100%;
  min-height: 100%;
}

.md-layout-item {
  background: #e3e3e3;
  border-radius: 8px;
  padding: 20px;
}

.md-layout-item:not(:last-child) {
  margin-right: 10px;
}

.header {
  background-color: white;
  border-radius: 5px;
  font-size: 16px;
  height: 40px;
  line-height: 40px;
  vertical-align: center;
  text-align: center;
  text-transform: uppercase;
  margin-bottom: 20px;  
}
</style>